import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import UserGalleryItem from './UserGalleryItem'

class UserTutorials extends React.Component {
  constructor() {
    super()

    this.state = {
      data: [],
    }

    this.fetchData = this.fetchData.bind(this)
    this.onRequestSuccess = this.onRequestSuccess.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchData()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  fetchData() {
    axios.get(`/api/internal/profile/${this.props.userName}/tutorials`,
      { cancelToken: this.cancelSource.token })
      .then((response) => {
        this.onRequestSuccess(response)
      }).catch(this.onRequestFailure)
  }

  onRequestSuccess(response) {
    this.setState({ data: response.data.data || [] })
  }

  onRequestFailure() {
    App.events.publish('app:notification:flash:error', 'Error')
  }

  render() {
    return (
      <Fragment>
        <div className="row user-profile__gallery-row">
          {this.state.data.map((tutorial) => (
            <UserGalleryItem
              key={`user-profile-gallery-${tutorial.id}`}
              data={tutorial.attributes}
              type="tutorial"
            />
          ))}
        </div>
      </Fragment>
    )
  }
}

UserTutorials.propTypes = {
  userName: PropTypes.string.isRequired,
}

export default UserTutorials
